import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ClimateLanding from "@/pages/ClimateLanding";

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ClimateLanding />} />
          <Route path="*" element={<ClimateLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
